import { render, staticRenderFns } from "./initial_item.vue?vue&type=template&id=19c1a847"
import script from "./initial_item.vue?vue&type=script&lang=js"
export * from "./initial_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports